import PhoneSettings from "../../components/feature/settings/phone/phone-settings";
import ScheduleSettings from "../../components/feature/settings/schedule/schedule-settings";
import GreetingSettings from "../../components/feature/settings/greeting/greeting-settings";
import SettingsTabPage from "../../components/feature/settings/settings-tab-page";
import { View } from "react-native";
import AgentIntro from "../../components/feature/settings/agent-intro";
import { useLocalSearchParams } from "expo-router";
import IntegrationSettings from "../../components/feature/settings/integration/integration-settings";

export default function GeneralTab() {
  const { section } = useLocalSearchParams();
  const sectionParam = section as string | undefined;

  return (
    <SettingsTabPage section={sectionParam}>
      <View className="pt-4 gap-8">
        <AgentIntro />
        <ScheduleSettings />
        <GreetingSettings />
        <PhoneSettings />
        <IntegrationSettings />
      </View>
    </SettingsTabPage>
  );
}
